export const unixTimeToMilliseconds = (unixTime: number) => unixTime * 1000;
